<template>
    <ModalBase @close="close">
        <div class="logo-container"><img :src="img" /></div>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";

export default {
    name: "ImgPreview",
    components: {
        ModalBase
    },
    props: {
        img: {
            type: String,
            required: false
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes";

.logo-container {
    margin: 20px auto;
    text-align: center;
    border: 1px #aaa solid;
    img {
        max-width: 600px;
        max-height: 300px;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// ImgPreview.vue?218ae93d